import { AdsCard } from '../Dashboard/AdsCard';
import FastTrade from '../Assets/Image/FastTrade.png';
import P2p from '../Assets/Image/P2p.png';
import { Graph } from './Graph';
export const Transactiongraph = () => {
  const contents = [
    {
      title: 'Fast FX Trade',
      paragraph: 'Secure and directly with Loyalty view',
      image: FastTrade,
      buttonText: 'Buy/Sell Now',
      to: '/tradecurrency/direct/buy',
    },
    {
      title: 'Secure P2P Trading',
      paragraph: 'Secure and directly with Loyalty view',
      image: P2p,
      buttonText: 'Buy/Sell Now',
      to: '/tradecurrency/p2p/buy',
    },
  ];
  return (
    <div className='grid lg:grid-cols-3 gap-6 w-full h-[25rem]'>
      <div className='col-span-3 lg:col-span-2 h-full overflow-x-auto w-full'>
        <Graph />
      </div>

      <div className='flex flex-col sm:flex-row lg:flex-col gap-6 col-span-3 lg:col-span-1'>
        {contents.map((content, index) => {
          return (
            <AdsCard
              key={index}
              image={content.image}
              title={content.title}
              paragraph={content.paragraph}
              buttonText={content.buttonText}
              to={content.to}
            />
          );
        })}
      </div>
    </div>
  );
};
